import "./KanbanView.css";

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

function getColKey(seccion) {
  const hasVisual = !!seccion.medioVisual;
  const hasAudio = seccion.mediosAudio && seccion.mediosAudio.length > 0;
  if (!hasVisual && !hasAudio) return "sin";
  if (hasVisual && !hasAudio) return "visual";
  if (!hasVisual && hasAudio) return "audio";
  return "completa";
}

const COLUMNS = [
  { key: "sin", label: "Sin medios", cssClass: "col-sin" },
  { key: "visual", label: "Solo visual", cssClass: "col-visual" },
  { key: "audio", label: "Solo audio", cssClass: "col-audio" },
  { key: "completa", label: "Completa", cssClass: "col-completa" },
];

export default function KanbanView({ exhibicion, selectedId, onSelectSection }) {
  const secciones = exhibicion?.secciones || [];

  const grouped = COLUMNS.reduce((acc, col) => {
    acc[col.key] = secciones.filter((s) => getColKey(s) === col.key);
    return acc;
  }, {});

  return (
    <div className="exhi-kanban">
      {COLUMNS.map((col) => (
        <div key={col.key} className={`exhi-kanban-col ${col.cssClass}`}>
          <div className="exhi-kanban-col-header">
            {col.label} ({grouped[col.key].length})
          </div>
          {grouped[col.key].map((s) => (
            <div
              key={s.idSeccion}
              className={`exhi-kanban-card${selectedId === s.idSeccion ? " exhi-kanban-card--selected" : ""}`}
              style={{ cursor: "pointer" }}
              onClick={() => onSelectSection && onSelectSection(s)}
            >
              <div className="exhi-kanban-card-title">{s.titulo}</div>
              <div className="exhi-kanban-card-time">
                {formatTime(s.tiempoInicio)} · {s.duracion}s
              </div>
            </div>
          ))}
          {grouped[col.key].length === 0 && (
            <div style={{ fontSize: "0.75rem", color: "#adb5bd", textAlign: "center" }}>—</div>
          )}
        </div>
      ))}
    </div>
  );
}
